import PersistentBanner from 'components//Header/PersistentBanner/PersistentBanner';
import { withPersistentBannerProps } from 'viewModel/bcc/bccPersistentBanner/withPersistentBannerProps';

export default withPersistentBannerProps(PersistentBanner);
